var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_16_default_image_icon",
    "data-name": "16 default image icon",
    transform: "translate(-532 -1648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 80,
    height: 80,
    transform: "translate(532 1648)",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_image",
    "data-name": "icon image",
    d: "M7.9,5.75A2.153,2.153,0,0,0,5.75,7.9V36.1a2.153,2.153,0,0,0,1.482,2.046l21.5-21.5a1.875,1.875,0,0,1,2.652,0l6.869,6.869V7.9A2.153,2.153,0,0,0,36.1,5.75ZM38.25,28.818l-8.194-8.194L12.429,38.25H36.1A2.153,2.153,0,0,0,38.25,36.1ZM2,7.9A5.9,5.9,0,0,1,7.9,2H36.1A5.9,5.9,0,0,1,42,7.9V36.1A5.9,5.9,0,0,1,36.1,42H7.9A5.9,5.9,0,0,1,2,36.1Zm12.951,5.9A1.146,1.146,0,1,0,16.1,14.951,1.146,1.146,0,0,0,14.951,13.806Zm-4.9,1.146a4.9,4.9,0,1,1,4.9,4.9A4.9,4.9,0,0,1,10.056,14.951Z",
    transform: "translate(549.758 1666.161)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.e3ae5da5ff99985a98c2bd37fb4ef7cd.svg";
export { ForwardRef as ReactComponent };